/***

[login]
const userInfo = await model.login("A001", "id_card_number");
// check has cache of statistics
if (userInfo.statistics === undefined) {
  // get statistic again
  const statistics = await model.getStatistics();
}

[getStatistics]
const statistics = await model.getStatistics();

[updateSymptom]
await model.updateSymptom();

[createContact]
const contact = await model.createContact("A001", "id_card_number");

[deleteContact]
await model.deleteContact(userInfo.contacts[0].userId);

***/

import {
  CreateContactDTO,
  DeleteContactDTO,
  LoginRequestDTO,
  RequireLoginDTO,
  UpdateSymptomDTO,
  SetContactUsernameDTO,
  UpdateContactCreatedAtDTO,
  Statistic,
  UserInfo,
  Contact,
} from './interfaces';
import { myFetch } from './myFetch';

let userId: string | null = null;

export async function login(loginId: string) {
  const data: LoginRequestDTO = { loginId };
  const res = await myFetch(data, '/login');
  if (res.result !== 'ok') return;
  const userInfo: UserInfo = res.userInfo;
  userId = userInfo.userId;
  return userInfo;
}

export async function getStatistics(): Promise<Statistic[] | undefined> {
  if (userId === null) {
    console.error('getStatistics api require login');
    return;
  }
  const data: RequireLoginDTO = { userId };
  const statistics: Statistic[] = await myFetch(data, '/getStatistic');
  return statistics;
}

export async function updateSymptom(symptoms: { [symptomId: string]: boolean }): Promise<boolean> {
  if (userId === null) {
    console.error('updateSymptom api require login');
    return false;
  }
  const data: UpdateSymptomDTO = { userId, symptoms };
  await myFetch(data, '/updateSymptom');
  return true;
}

export async function createContact(contactLoginId: string): Promise<Contact | undefined> {
  if (userId === null) {
    console.error('createContact api require login');
    return;
  }
  const data: CreateContactDTO = { userId, contactLoginId };
  const res = await myFetch(data, '/createContact');
  if (res.result !== 'ok') return;
  const contact = res.contact as Contact;
  return contact;
}

export async function updateContactCreatedAt(contactUserId: string): Promise<boolean> {
  if (userId === null) {
    console.error('updateContactCreatedAt api require login');
    return false;
  }
  const data: UpdateContactCreatedAtDTO = { userId, contactUserId };
  await myFetch(data, '/updateContactCreatedAt');
  return true;
}

export async function deleteContact(contactUserId: string): Promise<boolean> {
  if (userId === null) {
    console.error('deleteContact api require login');
    return false;
  }
  const data: DeleteContactDTO = { userId, contactUserId };
  await myFetch(data, '/deleteContact');
  return true;
}

export async function setContactUsername(
  contactUserId: string,
  contactUsername: string
): Promise<boolean> {
  if (userId === null) {
    console.error('setContactUsername api require login');
    return false;
  }
  const data: SetContactUsernameDTO = { userId, contactUserId, contactUsername };
  await myFetch(data, '/setContactUsername');
  return true;
}
